import * as types from 'api-paths-cas';

export type IEventType = types.EventTypeConfig;

export type IEventTypesState = Array<IEventType>;

export enum EventTypesTypes {
  GET_UNI_EVENT_TYPES = '@@event-types/GET_UNI_EVENT_TYPES',
  GET_UNI_EVENT_TYPES_SUCCESS = '@@event-types/GET_UNI_EVENT_TYPES_SUCCESS',
  GET_UNI_EVENT_TYPES_FAILURE = '@@event-types/GET_UNI_EVENT_TYPES_FAILURE',
}
